<template>
    <div class="float-left mr-1">
        <span class="text-success">
            <i
                class="fa fa-money fa-lg icon-button mr-1"
                title="Aprovar"
                @click.stop="detalharPagamento()"
            ></i>
        </span>
    </div>
</template>

<script>

export default {

    props: {
        pagamentoId: {
            type: String
        }
    },

    methods: {
        detalharPagamento() {
            this.$router.push({
                name: 'GesconAprovadoresPagamentoDetalhar',
                params: {
                    pagamentoId: this.pagamentoId
                }
            })
        }
    }
}


</script>